import { useMemo } from "react"
import { turbine } from "neql"
import { useNeqlContextProvider } from "./useNeqlContextProvider"

export type StructuredSequence = {
    key: number
    id: string | undefined
    step: number | undefined | null
    type: turbine.TrainingQuestionTutorialType | undefined | null
    summary: {
        jobId: string | undefined | null
        hint: string | undefined | null
        explanation: string | undefined | null
    }
    deletionInProgress: boolean
    isInteractive?: boolean | null
}

export const useStructuredTrainingQuestionTutorial = (
    trainingID: string
): [
    StructuredSequence[] | undefined,
    turbine.FetchTrainingQuestionTutorialsQueryHookResult["refetch"]
] => {
    const clientContext = useNeqlContextProvider("turbine")
    const { data: trainingQuestionTutorialsData, refetch } =
        turbine.useFetchTrainingQuestionTutorialsQuery({
            variables: {
                trainingID
            },
            client: clientContext
        })

    return useMemo(
        () => [
            trainingQuestionTutorialsData?.trainingQuestionTutorials?.map(
                (
                    item: turbine.TrainingQuestionTutorial | null,
                    index: number
                ) => {
                    if (item !== null) {
                        return {
                            key: index,
                            id: item.id,
                            step: item.sequence,
                            type: item.type,
                            summary: {
                                jobId: item.jobId,
                                hint: item.hint,
                                explanation: item.explanation
                            },
                            deletionInProgress: false,
                            isInteractive: item.interactive
                        }
                    }
                    return {
                        key: index,
                        id: undefined,
                        step: undefined,
                        type: undefined,
                        summary: {
                            jobId: undefined,
                            hint: undefined,
                            explanation: undefined
                        },
                        deletionInProgress: false,
                        isInteractive: false
                    }
                }
            ),
            refetch
        ],
        [trainingQuestionTutorialsData, refetch]
    )
}
